// Typed API calls for the auth screens — calls `instance` directly with
// typed generics, so callers get a real response type with no cast.
import instance from "../../config/axios";
import type { AxiosRequestConfig } from "axios";
import url from "../../constants/url";
import { Cclmodule, apiRoutes, routes } from "../../constants/routes";
import type {
  LoginPayload,
  LoginResponse,
  StepAuthResponse,
  VerifyOtpPayload,
  VerifyOtpResponse,
  UserDetailsByEmail,
  ForgotPasswordResponse,
  ConfirmForgotPasswordPayload,
  ConfirmForgotPasswordResponse,
} from "./types";

export const loginRequest = (data: LoginPayload): Promise<LoginResponse> =>
  instance.post<LoginResponse, LoginResponse>(
    `${url.packagingapiurl}${Cclmodule.users}/${routes.login}`,
    data
  );

export const sendResetCode = (email: string): Promise<ForgotPasswordResponse> =>
  instance.put<ForgotPasswordResponse, ForgotPasswordResponse>(
    `${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.password}/${routes.forgotPassword}/${encodeURIComponent(email)}`
  );

export const confirmReset = (data: ConfirmForgotPasswordPayload): Promise<ConfirmForgotPasswordResponse> =>
  instance.put<ConfirmForgotPasswordResponse, ConfirmForgotPasswordResponse>(
    `${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.password}/${routes.confirmForgotPassword}`,
    data
  );

export const fetchStepAuth = (pendingToken: string): Promise<StepAuthResponse> =>
  instance.post<StepAuthResponse, StepAuthResponse>(
    `${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.usertotp}`,
    { pending_token: pendingToken }
  );

export const verifyOtp = (payload: VerifyOtpPayload): Promise<VerifyOtpResponse> =>
  instance.post<VerifyOtpResponse, VerifyOtpResponse>(
    `${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.totverify}`,
    payload,
    // Skips config/axios.js's shared 401 -> forceLogout: here 401 means "wrong OTP", not an expired session.
    { skipAuthRedirect: true } as AxiosRequestConfig
  );

export const fetchUserDetailsByEmail = (email: string): Promise<UserDetailsByEmail> =>
  instance.get<UserDetailsByEmail, UserDetailsByEmail>(
    `${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.detailsId}/${encodeURIComponent(email)}`
  );
